const CONSENT_COOKIE_NAME = "fivebits_cookie_consent";
const CONSENT_VERSION = "2026-06-11";

const getCookieValue = (name) => {
  if (typeof document === "undefined") return null;

  return document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split("=")[1];
};

export const readAnalyticsConsent = () => {
  const rawConsent = getCookieValue(CONSENT_COOKIE_NAME);
  if (!rawConsent) return { analytics: false, marketing: false };

  try {
    const consent = JSON.parse(decodeURIComponent(rawConsent));
    if (consent.version !== CONSENT_VERSION) {
      return { analytics: false, marketing: false };
    }

    return {
      analytics: Boolean(consent.preferences?.analytics),
      marketing: Boolean(consent.preferences?.marketing),
    };
  } catch {
    return { analytics: false, marketing: false };
  }
};

export const hasTrackingConsent = () => {
  const consent = readAnalyticsConsent();
  return consent.analytics || consent.marketing;
};

export const pushToDataLayer = (payload) => {
  if (typeof window === "undefined" || !hasTrackingConsent()) return false;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  return true;
};

export const trackPageView = (location = window.location) => {
  if (!hasTrackingConsent()) return false;

  return pushToDataLayer({
    event: "page_view",
    page_path: `${location.pathname}${location.search}`,
    page_location: location.href,
    page_title: document.title,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!eventName || !hasTrackingConsent()) return false;

  return pushToDataLayer({
    event: eventName,
    ...params,
  });
};

export const CONTACT_FORM_SOURCES = {
  CONTACT: "contact",
  AI_WORKFLOW: "ai-workflow",
  SAAS_MVP: "saas-mvp",
};

const CONTACT_FORM_SOURCE_VALUES = new Set(Object.values(CONTACT_FORM_SOURCES));

export const trackContactFormSubmit = (formSource, params = {}) => {
  const source = CONTACT_FORM_SOURCE_VALUES.has(formSource)
    ? formSource
    : CONTACT_FORM_SOURCES.CONTACT;

  const location =
    typeof window !== "undefined" ? window.location : { pathname: "", href: "" };

  return trackEvent("contact_form_submit", {
    form_source: source,
    page_path: `${location.pathname}${location.search}`,
    page_location: location.href,
    page_title: typeof document !== "undefined" ? document.title : "",
    ...params,
  });
};
